<template>
  <div>
    <div :id="id" class="wordcloud-canvas"></div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import 'echarts-wordcloud'
import dayjs from 'dayjs'
import request from '@/utils/request'

export default {
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      keywords: [],
    }
  },
  async mounted() {
    await this.getTeamListInfo()
    await this.initEchart()
  },
  methods: {
    initEchart() {
      const echartDom = document.getElementById(this.id)
      const chart = echarts.init(echartDom, null, { devicePixelRatio: 2.5 })
      // 数据必须是一个数组，数组是对象，对象必须有name和value属性

      chart.setOption({

        series: [{
          type: 'wordCloud',
          // shape这个属性虽然可配置，但是在词的数量不太多的时候，效果不明显，它会趋向于画一个椭圆
          shape: 'circle',
          // keepAspect 保持maskImage的纵横比或1:1的形状,
          keepAspect: true,
          // 这个是可以自定义背景图片的，词云会按照图片的形状排布，所以有形状限制的时候，最好用背景图来实现，而且，这个背景图一定要放base64的，不然词云画不出来
          // maskImage,
          // 下面就是位置的配置
          left: 'center',
          top: 'center',
          width: '100%',
          height: '100%',
          right: null,
          bottom: null,
          // 词的大小，最小12px，最大60px，可以在这个范围调整词的大小
          sizeRange: [12, 60],
          // 每个词旋转的角度范围和旋转的步进
          rotationRange: [0, 0],
          rotationStep: 45,
          // 词间距，数值越小，间距越小，这里间距太小的话，会出现大词把小词套住的情况，比如一个大的口字，中间会有比较大的空隙，这时候他会把一些很小的字放在口字里面，这样的话，鼠标就无法选中里面的那个小字，这里可以用函数根据词云的数量动态返回间距
          gridSize: 15,
          // 允许词太大的时候，超出画布的范围
          drawOutOfBound: false,
          // 布局的时候是否有动画
          layoutAnimation: true,
          // 这是全局的文字样式，相对应的还可以对每个词设置字体样式
          textStyle: {
            fontFamily: 'sans-serif',
            fontWeight: 'bold',
            // 三色随机色
            color () {
              // Random color
              if (Math.round(Math.random() * 100) > 0 && Math.round(Math.random() * 100) <= 30) {
                return '#3C6EF0'
              } if (Math.round(Math.random() * 100) > 30 && Math.round(Math.random() * 100) <= 60) {
                return '#12B35D'
              }
              return '#3AD3D9'
            }
          },
          emphasis: {
            focus: 'self',
            textStyle: {
              textShadowBlur: 1,
              // textShadowColor: '#333'
            },
            itemStyle: {
              shadowBlur: 10,
            },
          },
          grid: {
            top: '0',
            bottom: '0%',
            left: '0%',
            right: '0%',
          },
          // 数据必须是一个数组，数组是对象，对象必须有name和value属性
          data: this.keywords
        }]
      })
    },
    async getTeamListInfo() {
      try {
        // 获取当前日期
        const day = dayjs()
        // 格式化为年月日
        const formattedToday = day.format('YYYY-MM-DD')
        // 获取三个月前的日期
        const sixMonthsAgo = day.subtract(6, 'month')
        // 格式化为年月日
        const formattedSixMonthsAgo = sixMonthsAgo.format('YYYY-MM-DD')
        const res = await request({
          url: '/customer/extractHFKeywords/wo/',
          method: 'get',
          params: {
            beginTime: formattedSixMonthsAgo,
            endTime: formattedToday,
            n: 50
          },
          headers: {
            'Content-Type': 'application/json',
          },
        })
        const { data } = res
        this.keywords = data
      } catch (error) {
        console.log(error)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.wordcloud-canvas {
  width: 566px;
  height: 362px;
  // border: 1px solid #eee;
  background-color: #FBFBFB;
}
</style>
